/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';
import { getIconPath } from '@tcp/core/src/utils';
import Col from '@tcp/core/src/components/common/atoms/Col';
import Row from '@tcp/core/src/components/common/atoms/Row';
import { THANKYOU_ICON_FILL_COLOUR } from '@tcp/core/src/constants/brandSpecific.constants';

const getNavBorderColor = (props) => {
  return props.isNewNavigationImagesEnabled
    ? props.theme.colorPalette.gray[3200]
    : THANKYOU_ICON_FILL_COLOUR[props?.brandId?.toUpperCase()];
};

const style = css`
  box-sizing: border-box;
  position: relative;
  text-align: center;

  @media ${(props) => props.theme.mediaQuery.large} {
    margin: 0;
    border-bottom: 1px solid;
    border-color: ${(props) => getNavBorderColor(props)};
    width: 100%;
  }
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    #search-input-wrapper {
      height: 33px;
    }
  }
  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    width: 100%;
    margin: 0;
  }
  .brands-wrapper {
    max-width: 100%;
    width: 100%;
    @media ${(props) => props.theme.mediaQuery.large} {
      width: 30%;
    }
    @media ${(props) => props.theme.mediaQuery.xlarge} {
      max-width: 440px;
      width: 440px;
    }
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      border-bottom: 1px solid;
      border-color: ${(props) => getNavBorderColor(props)};
    }
    .header-topnav-brand-tabs {
      background-color: ${(props) => props.theme.colorPalette.blue.C900};
    }
  }
  #contentWrapperNav,
  .content-wrapper-nav {
    max-width: 1440px;
    margin: 0 auto;
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      margin: 0;
      width: 100%;
    }
  }

  .flexbox {
    display: flex;
  }

  .hamburger-menu {
    outline: none;
    cursor: pointer;
    width: 20px;
    height: 20px;
  }
  ${(props) =>
    `
      @media ${props.theme.mediaQuery.smallMax} {
      &.header-middle-nav{
        margin:0;
        width: 100%;
      }
    }
    .user-profile-wrapper{
      width: 42px;
    height: 42px;
    display: flex;
    justify-content: center;
    align-items: center;
    @media ${props.theme.mediaQuery.mediumMax} {
      width: 32px;
      height: 32px;
      .user-profile-icon{
        width: 17px;
        height: 17px;
        }
    }
    }
  `}
  .user-profile-icon {
    padding-top: 6%;
  }
  .loggedin-username-initials-block {
    border-radius: 50%;
    color: black;
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border: solid 1px ${(props) => props.theme.colors.WHITE};
    background-color: #f5f5f5;
  }
  .loggedin-fullname-text {
    font-size: 9px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #1a1a1a;
    display: none;
    @media ${(props) => props.theme.mediaQuery.large} {
      display: block;
    }
  }
  .loggedin-username-initials-text {
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    text-transform: uppercase;
    font-size: 21px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: black;
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      font-size: 16px;
    }
  }

  .header-middle-nav-search {
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 34px;
      height: 62px;
      margin-left: 16px;
    }
    @media (max-width: 450px) {
      width: 24px;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      display: none;
    }
  }

  .user-name-new-header {
    font-weight: 9px;
  }
  /*===========SVG icons Styles====== */

  .svg-icon-wrapper {
    display: inline-block;
    border-radius: 50%;
    margin-right: 12px;
    height: 32px;
    width: 32px;
    cursor: pointer;
    @media (max-width: 450px) {
      margin-right: 6px;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      border: none;
      margin-right: 16px;
      height: 42px;
      width: 42px;
    }
  }
  .user-profile-icon .svg-icon-wrapper {
    @media (max-width: 450px) {
      margin-right: 0px;
    }
  }
  /*===========SVG icons Styles End====== */

  .store-locator-link-snj {
    display: none;
  }

  .header-middle-login-section {
    @media ${(props) => props.theme.mediaQuery.largeOnly} {
      background-color: ${(props) => props.theme.colorPalette.blue.C900};
    }
    justify-content: space-between;
    align-items: center;
    display: flex;
    @media ${(props) => props.theme.mediaQuery.large} {
      width: 70%;
    }
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      width: calc(100% - 50px);
    }

    @media ${(props) => props.theme.mediaQuery.xlarge} {
      width: calc(100% - 440px);
    }
    @media (max-width: 450px) {
      width: calc(100% - 40px);
    }

    .headerSearchBox-wrapper-new {
      width: 587px;

      @media ${(props) => props.theme.mediaQuery.largeOnly} {
        width: 460px;
      }
      @media ${(props) => props.theme.mediaQuery.mediumMax} {
        width: 100%;
      }
      .searchBar-input {
        width: calc(100% - 70px);
      }
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        ${(props) =>
          props.showCondensedHeader &&
          !props.isSearchEnhancementRedesignEnabled &&
          `display:none;`};
      }
    }

    .searchBar-image-typeAhead svg {
      right: 16px;
      @media (max-width: 450px) {
        height: 11px;
        width: 11px;
        right: 8px;
        top: 10px;
      }
    }
    #search-input-wrapper {
      width: 100%;
      margin: 0;
      @media (max-width: 450px) {
        width: 100%;
      }
      .visuallyhidden {
        width: 100%;
      }
    }
    /* stylelint-disable max-nesting-depth */
    /* stylelint-disable no-descending-specificity*/
    .content-wrapper-left {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-grow: 3;
      @media ${(props) => props.theme.mediaQuery.medium} {
        flex-grow: 9;
      }
      @media ${(props) => props.theme.mediaQuery.mediumMax} {
        .countrySelector {
          display: none;
        }
      }
      @media ${(props) => props.theme.mediaQuery.large} {
        justify-content: center;
      }
      @media ${(props) => props.theme.mediaQuery.xlarge} {
        width: calc(100% - 280px);
        margin: 0 20px 0 18px;
      }
      @media ${(props) => props.theme.mediaQuery.smallMax} {
        ${(props) => (props.isSearchBarAlignmentEnabled ? `z-index:  50;` : '')}
      }
    }
    .content-wrapper-right {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      flex-grow: ${(props) => (props.isHamburgerMenuRedesignEnabled ? 0 : 1)};
      @media ${(props) => props.theme.mediaQuery.small} {
        margin-top: 5px;
      }
      @media ${(props) => props.theme.mediaQuery.xlarge} {
        max-width: 280px;
      }
      @media ${(props) => props.theme.mediaQuery.large} {
        margin-top: 5px;
      }
      ${(props) =>
        props.isHamburgerMenuRedesignEnabled &&
        `
      @media ${props.theme.mediaQuery.mediumOnly} {
        margin-left: ${props.theme.spacing.ELEM_SPACING.SM};
      }
      `}

      #cartIcon {
        .cartCount {
          background: ${(props) => props.theme.colors.BLACK};
          color: ${(props) => props.theme.colors.WHITE};
          border-radius: 8px;
          padding: 1px 5px;
          vertical-align: bottom;
          position: absolute;
          bottom: 10px;
          right: 20px;
          font-size: ${(props) => props.theme.typography.fontSizes.fs10};
          font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
          font-family: inherit;

          @media ${(props) => props.theme.mediaQuery.mediumMax} {
            border-radius: 50%;
            padding: 0px 3px;
            font-weight: 400;
            border: none;
            font-family: inherit;
            bottom: 9px;
            right: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
            font-size: 8px;
          }
        }
      }
      @media ${(props) => props.theme.mediaQuery.smallMax} {
        ${(props) => (props.isSearchBarAlignmentEnabled ? `flex-grow:  0;` : '')}
      }
    }
  }

  .headerSearchBox-wrapper-new {
    ${(props) =>
      props.showCondensedHeader
        ? ` width:1440px;
            position:fixed;
            z-index: 1200;
            top: 14px;
            margin: 0 auto;
            text-align: center;`
        : ``};
  }

  .header-middle-login-section .headerSearchBox-new {
    ${(props) =>
      props.showCondensedHeader && props.isSearchOpen
        ? `position: absolute;
          right: -104px;
            height: 40px;
         `
        : `position: relative;  height: 40px;
        `};
    flex-grow: unset;
    height: 100%;
    display: flex;
    align-content: center;
    justify-content: center;
    @media ${(props) => props.theme.mediaQuery.largeOnly} {
      ${(props) =>
        props.showCondensedHeader &&
        props.isSearchOpen &&
        `position: absolute;
          right: -154px;
            height: 40px;
         `}
    }

    @media (max-width: 450px) {
      margin: 0 5px;
      padding-left: 4px;
    }
    #search-input {
      ${(props) => props.showCondensedHeader && props.isSearchOpen && `width: 486px;`};
      @media ${(props) => props.theme.mediaQuery.largeOnly} {
        ${(props) => props.showCondensedHeader && props.isSearchOpen && `width:386px;`};
      }
    }
    #searchBar-input {
      ${(props) => props.showCondensedHeader && props.isSearchOpen && `width: 437px;`};
      @media (max-width: 450px) {
        font-size: 10px;
        width: calc(100% - 16px);
      }
    }
  }
  .search-input-wrapper {
    margin-right: 3px;
    border: 1px solid #ddd !important;

    @media ${(props) => props.theme.mediaQuery.small} {
      margin-right: 30px;
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      margin-right: 54px;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-right: 37px;
    }

    ${(props) =>
      `
      @media ${props.theme.mediaQuery.smallOnly} {
        width: 180px;
      }

      @media (max-width: ${props.theme.breakpoints.small}) {
        width: 175px;
      }
    `}
  }

  .account-info-section {
    display: inline-block;
    line-height: normal;
    background: none;
    border: none;
    padding: 0;
    margin-right: 12px;
    margin-top: -5px;
    @media (max-width: 450px) {
      margin-right: 6px;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-right: 0px;
    }
    ${(props) =>
      props.isHamburgerMenuRedesignEnabled &&
      `
    @media ${props.theme.mediaQuery.mediumOnly} {
      margin-right: 0px;
      margin-left: ${props.theme.spacing.ELEM_SPACING.SM};
    }
    `}
  }

  .carrot-down-icon {
    display: inline-block;
    cursor: pointer;
    margin-left: 5px;
    height: 5px;
    transform: rotate(0deg);
    transition: transform 0.1s linear;
  }
  .carrot-up-icon {
    display: inline-block;
    cursor: pointer;
    margin-left: 9px;
    transform: rotate(180deg);
    transition: transform 0.15s linear;
  }
  .account-info-wrapper {
    width: max-content;
    position: absolute;
    bottom: -11px;
    left: 0px;
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      display: none;
    }
  }
  .account-info {
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    display: none;
    @media ${(props) => props.theme.mediaQuery.medium} {
      display: inline-flex;
      align-items: center;
    }
  }

  .new-header-carrot-icon.account-info.carrot-down-icon,
  .new-header-carrot-icon.account-info.carrot-up-icon {
    content: url('${(props) => getIconPath('down_arrow_icon_white', props)}');
    background-color: none;
    padding: 0;
    border: none;
  }
  .user-name {
    cursor: pointer;
    font-size: ${(props) => props.theme.typography.fontSizes.fs9};
    text-align: left;
    color: ${(props) => props.theme.colors.WHITE};
    &:hover {
      color: ${(props) => props.theme.colorPalette.blue[500]};
    }
  }
  .user-points,
  .user-rewards {
    cursor: pointer;
    font-size: ${(props) => props.theme.typography.fontSizes.fs10};
    color: ${(props) =>
      props.isUserPlcc ? props.theme.colorPalette.blue[500] : props.theme.colorPalette.orange[800]};
  }

  .user-icon-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    @media (max-width: 450px) {
      margin-right: 6px;
    }
  }

  .user-rewards-pill {
    background-color: ${(props) =>
      props.isUserPlcc
        ? props.theme.colorPalette.userTheme.plcc
        : props.theme.colorPalette.userTheme.mpr};
    margin-top: -1px;
    padding: 2px 8px 0 8px;
    line-height: 1.1;
    border-radius: 6px;
    font-size: 10px;
    position: absolute;
    bottom: 12px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      bottom: 0px;
    }
  }

  .usericon {
    cursor: pointer;
    display: inline-flex;
    vertical-align: baseline;
    width: 23px;
    max-width: initial;
  }

  .usericon-reduced {
    width: 18px;
    margin-top: 0;
  }

  .product-image {
    height: 25px;
    width: 20px;
    margin-left: 9px;
    @media ${(props) => props.theme.mediaQuery.small} {
      margin-left: 25px;
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      width: 23px;
    }
    vertical-align: middle;
  }
  #login {
    padding-right: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
  }
  #createaccount {
    padding-left: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
  }

  .rightLink {
    border-left: 1px solid ${(props) => props.theme.colorPalette.gray[500]};
    box-sizing: border-box;
    margin-left: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    padding-left: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    min-width: ${(props) => props.theme.spacing.ELEM_SPACING.XXXL};
    border-radius: 0px;
  }
  .snjBorder {
    border-left: 1px solid ${(props) => props.theme.colors.PRIMARY.DARK};
    @media ${(props) => props.theme.mediaQuery.medium} {
      border-left: 1px solid ${(props) => props.theme.colorPalette.gray[500]};
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      border-left: 1px solid ${(props) => props.theme.colorPalette.gray[500]};
    }
  }
  .header-middle-login-section a {
    position: relative;
  }

  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    /* padding: 16px 0; */
    text-align: left;
    .header-brand__home-logo--brand {
      display: none;
    }
  }

  @media ${(props) => props.theme.mediaQuery.large} {
    /* padding: 31px 0 0; */
    .hamburger-menu {
      display: none;
    }
  }

  @media ${(props) => props.theme.mediaQuery.smallMax} {
    .storelocatorlink__container,
    .storelocatorlink__container--fav {
      display: block;
    }
  }

  .header-middle-nav-storelocator {
    display: flex;
    align-items: center;

    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      display: none;
    }
  }

  .create-account-header-label,
  .login-header-label {
    display: none;
    @media ${(props) => props.theme.mediaQuery.medium} {
      display: inline-flex;
    }
  }

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    .mini-bag-icon {
      width: 25px;
    }
  }

  .mobile-locator-icon {
    position: relative;
    top: 2px;
    display: block;
  }
`;

export const customHeaderStyle = css`
  .Modal_Heading {
    border-bottom: none;
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    font-size: ${(props) => props.theme.typography.fontSizes.fs22};
    display: flex;
    justify-content: center;
    height: auto;
    padding-bottom: 0;
    @media ${(props) => props.theme.mediaQuery.medium} {
      display: flex;
      justify-content: center;
      height: auto;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XL};
    }
  }
  .close-modal {
    display: none;
  }
`;

export const NavigationColumn = styled(Col)`
  background-color: ${(props) => props.theme.colorPalette.white};
  ${(props) =>
    props.isNewNavigationImagesEnabled
      ? `
  @media ${props.theme.mediaQuery.large} {
  height: 170px;
  }
  `
      : ``}
`;

export const NavigationRow = styled(Row)`
  ${(props) =>
    props.isStickyHeaderNav
      ? `
      background-color: ${props.theme.colorPalette.white};
        @media ${props.theme.mediaQuery.mediumMax} {
          width: 100%;
          margin: 0;
        }
      `
      : ``}
`;

export default style;
